import { render, staticRenderFns } from "./affirmOkrWorkSplit.vue?vue&type=template&id=a3bba1ec&scoped=true&"
import script from "./affirmOkrWorkSplit.vue?vue&type=script&lang=js&"
export * from "./affirmOkrWorkSplit.vue?vue&type=script&lang=js&"
import style0 from "./affirmOkrWorkSplit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./affirmOkrWorkSplit.vue?vue&type=style&index=1&id=a3bba1ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bba1ec",
  null
  
)

component.options.__file = "affirmOkrWorkSplit.vue"
export default component.exports